import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { qk } from '@/shared/api/keys';
import { haptic } from '@/shared/lib/haptic';
import { fetchCoordinatorStatus, requestCoordinatorRun } from './api';

/**
 * Статус координатора, опрашиваемый поллингом.
 * - Пауза, когда вкладка в фоне (document.hidden) — не жжём запросы зря.
 * - Быстрее (2с), пока запрос в очереди, чтобы кнопка быстро перешла в «В работе».
 * - Иначе раз в 5с.
 */
export function useCoordinatorStatus() {
  return useQuery({
    queryKey: qk.coordinatorStatus,
    queryFn: fetchCoordinatorStatus,
    retry: false,
    refetchIntervalInBackground: false,
    refetchInterval: (query) => {
      if (typeof document !== 'undefined' && document.hidden) return false;
      return query.state.data?.status === 'queued' ? 2000 : 5000;
    },
  });
}

/** Кнопка «Запустить координатора» → POST /run; статус подхватит поллинг. */
export function useRequestCoordinatorRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: requestCoordinatorRun,
    onSuccess: () => {
      haptic('success');
      void qc.invalidateQueries({ queryKey: qk.coordinatorStatus });
    },
    onError: () => haptic('error'),
  });
}
